import React from 'react';
import { Wrap, EasyActions, EasyWin, Loader } from '../../components/index';
import * as _ from 'lodash';
import { useResponsivity } from '../../helpers/helpers';
import { Row, Col } from 'react-styled-flexboxgrid';
import { useTranslation } from 'react-i18next';
import store from 'store2';
interface UrinalsProps {
  challenges: any;
  listLocation: any;
  getChallengeCategory: Function;
  completeTask: any;
  completeChallenge: Function;
  generalData: Function;
  getOffers: Function;
}

const Urinals: React.FC<UrinalsProps> = (props) => {
  const {
    challenges,
    listLocation,
    getChallengeCategory,
    completeTask,
    completeChallenge,
    generalData,
    getOffers,
  } = props;
  const getRoomId = store('property');
  const { error, loading, done } = _.get(completeTask, 'status');
  const loadingChallenges = _.get(challenges, 'status.loading');
  const data = _.get(challenges, 'data.challenges');
  const offers = _.get(challenges, 'offers.data.challenges');

  const isMobile = useResponsivity();
  const plumberVisit = _.find(offers, function (o) {
    return o.tag.includes('PLUMBER_VISIT');
  });
  const [t] = useTranslation('common');

  React.useEffect(() => {
    getChallengeCategory(getRoomId, 'bathroom-urinal');
    getOffers(getRoomId);
  }, [getRoomId]);
  const pageArray = [
    {
      id: 267,
      title: 'Urinals',
      icon: 'urinal',
      description:
        'Fitting a flush control to urinals significantly reduces water use, in particular during evenings and at weekends.',
      easyWins: [
        {
          title: 'Engage staff',
          size: 'half',
          hasLogo: false,
          description: [
            'Encourage staff to report if they spot water running down the back of the urinal between flushes. Cisterns that leak into urinals often leave a telltale blue-ish copper streak on the urinal pan.',
          ],
        },
        {
          title: 'Tell us your achievements',
          description: [
            'Confirm which actions you’ve completed to see how much water and money we think you’ll save.',
          ],
          theme: 'blue',
          size: 'half',
          hasLogo: false,
          isEasyAction: true,
        },
        {
          title: 'Plumber Tips',
          size: 'half',
          icon: 'toilet',
          hasLogo: false,
          description: [
            'Check the flush control mechanism to ensure the urinals flush in a timely manner depending on the number of male staff using the facilities. Make sure the flush control does not operate in the same way after working hours, particular during the night and weekends when your business premises may be unoccupied.',
          ],
        },
        {
          title: 'Fix a leak',
          size: 'half',
          hasLogo: false,
          icon: 'fixLeak',
          buttonText:
            plumberVisit !== undefined
              ? 'Book a Free plumber visit'
              : 'Find a plumber',
          linkType:
            plumberVisit !== undefined ? 'internalLink' : 'externalLink',
          buttonPath:
            plumberVisit !== undefined
              ? '/actions'
              : 'https://www.watersafe.org.uk',
          buttonIcon: null,
          description: [
            'Urinals with a strong leak could be wasting as much as 150,000 litres every year per cistern. Even small leaks waste water – and if unfixed, can turn into much stronger leaks over time.',
          ],
        },

        {
          title: 'Smart products',
          theme: 'green',
          size: 'full',
          hasLogo: true,
          icon: null,
          linkType: 'externalLink',
          buttonText: 'Find urinal flush controls',
          buttonPath:
            'https://uk.getwatersmart.com/products?category=CommercialUrinals',
          description: [
            'Fit a control to the urinal cistern to ensure urinals flush at the correct frequency and only during working hours. A control avoids overnight and weekend flushing when staff are at home. Urinals without controls can waste as much as 200,000 litres every year.',
            'Flush controls come in various forms – automatic, sensor, waterless – your Facilities Manager or plumber will recommend which is most suitable for your premises and will adjust the frequency and timings to minimise wasted water.',
          ],
        },
      ],
    },
  ];

  const getChallenges = () => {
    return _.map(data, (el, index) => {
      const title = _.get(el, 'title');
      const description = _.get(el, 'description');
      const buttonText = _.get(el, 'buttonText');
      const type = _.get(el, 'internalType');
      const buttonPath = _.get(el, 'buttonPath');
      const energySaving = _.get(el, 'energy_saving');
      const carbonSaving = _.get(el, 'carbon_saving');
      const waterSaving = _.get(el, 'water_saving');
      const exType = _.get(el, 'type');
      return (
        <Col xs={12} sm={12} md={12} key={index}>
          <EasyActions
            isDesktop={!isMobile}
            icon={_.get(el, 'icon')}
            id={_.get(el, 'id')}
            title={`${t(title)}`}
            description={`${t(description)}`}
            buttonText={`${t(buttonText)}`}
            buttonPath={buttonPath}
            popup={type === 'direct-redirect' ? false : true}
            renderComplete={() => {
              completeChallenge(getRoomId, _.get(el, 'id'));
              setTimeout(() => {
                getChallengeCategory(getRoomId, 'bathroom-urinal');
                generalData();
              }, 1000);
            }}
            isLoading={loading}
            completed={done}
            energySaving={energySaving}
            carbonSaving={carbonSaving}
            waterSaving={waterSaving}
            type={exType}
          />
        </Col>
      );
    });
  };
  if (loadingChallenges) {
    return (
      <Wrap>
        <Loader />
      </Wrap>
    );
  }
  return (
    <Wrap>
      <EasyWin data={pageArray}>
        <Row style={{ marginTop: '16px' }}>{getChallenges()}</Row>
      </EasyWin>
    </Wrap>
  );
};

export default Urinals;
